import React from "react";
import { string } from "prop-types";

import DrawerModal from "../../../../shared/components/DrawerModal";
import ErrorMessage from "../../../../shared/components/ErrorMessage";
import LoadingIndicator from "../../../../shared/seller-services/components/LoadingIndicator";
import MODAL_VIEW_TYPES from "../../constants/modalViewTypes";
import { useUIBehavior, useUIData } from "../../redux/hooks/uiHooks";
import AgentContactForm from "../AgentContactForm";
import MessageSent from "../MessageSent";
import * as S from "./styled";

const ExpertMatchDrawer = ({ rootElementId }) => {
  const { isExpertMatchDrawerOpen, modalViewType } = useUIData();
  const { closeExpertMatchDrawer } = useUIBehavior();

  const ariaLabelledBy = "modal_label";
  const ariaDescribedBy = "modal_description";

  const modalAriaLabel =
    modalViewType === MODAL_VIEW_TYPES.success ||
    modalViewType === MODAL_VIEW_TYPES.agentContact
      ? ariaLabelledBy
      : null;

  const modalAriaDescription =
    modalViewType === MODAL_VIEW_TYPES.success ||
    modalViewType === MODAL_VIEW_TYPES.agentContact
      ? ariaDescribedBy
      : null;

  const views = {
    [MODAL_VIEW_TYPES.agentContact]: (
      <>
        <S.FormHeader
          ariaContentDescribedBy={ariaDescribedBy}
          ariaContentLabelledBy={ariaLabelledBy}
        />
        <S.AgentCard />
        <AgentContactForm handleCancelClick={closeExpertMatchDrawer} />
      </>
    ),
    [MODAL_VIEW_TYPES.loading]: (
      <S.MessageContainer>
        <LoadingIndicator>
          <S.LoadingText>
            Finding you the right
            <br />
            agent…
          </S.LoadingText>
        </LoadingIndicator>
      </S.MessageContainer>
    ),
    [MODAL_VIEW_TYPES.error]: (
      <S.MessageContainer>
        <ErrorMessage>
          Sorry, something went wrong.
          <br />
          Please try again later.
        </ErrorMessage>
      </S.MessageContainer>
    ),
    [MODAL_VIEW_TYPES.success]: (
      <S.MessageContainer>
        <MessageSent
          ariaContentDescribedBy={ariaDescribedBy}
          ariaContentLabelledBy={ariaLabelledBy}
        />
      </S.MessageContainer>
    )
  };

  return (
    <DrawerModal
      aria={{
        describedby: modalAriaDescription,
        labelledby: modalAriaLabel
      }}
      handleOnClose={closeExpertMatchDrawer}
      isOpen={isExpertMatchDrawerOpen}
      render={() => (
        <S.ModalContent data-qa="seller-expert-match-drawer">
          <S.XButton
            modalViewType={modalViewType}
            onClick={closeExpertMatchDrawer}
          />
          <S.ContentContainer aria-live="polite">
            {views[modalViewType]}
          </S.ContentContainer>
        </S.ModalContent>
      )}
      rootElementId={rootElementId}
    />
  );
};

ExpertMatchDrawer.propTypes = {
  rootElementId: string.isRequired
};

export default ExpertMatchDrawer;
